// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__ESFCarousel from "./ESFCarousel.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function ESFOutro(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h4", {
                children: "Электронные счета-фактуры",
                className: "h4 lg:h2 text-black-landing w-62.5 lg:w-112.5"
              }),
              JsxRuntime.jsx("p", {
                children: "Делайте и получайте счета-фактуры прямо в Бухте. Теперь не нужно входить в отдельные системы для работы со счетами-фактурами. Все входящие счета-фактуры автоматически появятся у вас в кабинете, а вы сможете подготовить и отправить их не переключаясь между системами.",
                className: "paragraph-large lg:h-light lg:w-122 mt-2 text-black-landing"
              })
            ],
            className: "lg:flex lg:m-auto lg:w-252 lg:flex-col"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "workflow",
                    src: StaticAsset.src("/static/icons/workflow1.svg")
                  }),
                  JsxRuntime.jsx("h6", {
                    children: "Производителю",
                    className: "h6 text-black-landing mt-2"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Автоматически выставляйте ЭСФ при реализации и получайте при закупе комплектующих.",
                    className: "paragraph-small lg:paragraph text-gray-landing mt-2"
                  })
                ],
                className: "w-38.75 lg:w-57"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/workflow2.svg")
                  }),
                  JsxRuntime.jsx("h6", {
                    children: "Транспортная компания",
                    className: "h6 text-black-landing mt-2"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Выставляйте ЭСФ и АВР за свои услуги по перевозке и за комиссионные по приему оплаты.",
                    className: "paragraph-small lg:paragraph text-gray-landing mt-2"
                  })
                ],
                className: "w-38.75 lg:w-57"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/workflow3.svg")
                  }),
                  JsxRuntime.jsx("h6", {
                    children: "Торговая компания",
                    className: "h6 text-black-landing mt-2"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Сокращение бумажного документооборота с курьерами и прямое получение документов бухгалтерами и складскими сотрудниками.",
                    className: "paragraph-small lg:paragraph text-gray-landing mt-2"
                  })
                ],
                className: "mt-4 sm:mt-0 w-38.75 lg:w-57"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/workflow4.svg")
                  }),
                  JsxRuntime.jsx("h6", {
                    children: "Индивидуальный предприниматель",
                    className: "h6 text-black-landing mt-2"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Делайте АВР и ЭСФ по сразу же по запросу клиента, с предварительным согласованием с ним черновика.",
                    className: "paragraph-small lg:paragraph text-gray-landing mt-2"
                  })
                ],
                className: "mt-4 sm:mt-0 w-38.75 lg:w-57"
              })
            ],
            className: "flex justify-between flex-wrap m-auto mt-10 lg:mt-20 lg:w-252"
          })
        ],
        className: "bg-bg py-20 lg:py-40 px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h4", {
            children: "Благодаря Бухте вы сможете внедрить СНТ гораздо проще и удобнее",
            className: "h4 lg:h3 lg:flex lg:m-auto lg:text-center lg:w-200 text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "В случае налоговой проверки вы сможете открыть Бухту и показать почему вы указали именно ту или эту цифру в отчете.",
            className: "paragraph-large lg:h-light lg:flex lg:mx-auto mt-2 lg:text-center lg:w-200 text-black-landing"
          })
        ],
        className: "py-10 lg:pt-40 lg:pb-20 px-6 sm:px-48 lg:px-0"
      }),
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__ESFCarousel.make, {}) : JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "flex m-auto w-60",
                  alt: "manufacturer",
                  src: StaticAsset.src("/static/images/manufacturer.png")
                }),
                JsxRuntime.jsx("h4", {
                  children: "Производитель",
                  className: "h4 text-center text-black-landing mt-8"
                }),
                JsxRuntime.jsx("p", {
                  children: "Создавайте СНТ на произведенные товары.",
                  className: "paragraph text-center text-gray-landing mt-2 h-18"
                })
              ],
              className: "w-78.75"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "flex m-auto w-60",
                  alt: "seller",
                  src: StaticAsset.src("/static/images/seller.png")
                }),
                JsxRuntime.jsx("h4", {
                  children: "Продавец",
                  className: "h4 text-center text-black-landing mt-8"
                }),
                JsxRuntime.jsx("p", {
                  children: "Просматривайте входящие СНТ и принимайте или отклоняйте их, выставляйте СНТ покупателям.",
                  className: "paragraph text-center text-gray-landing mt-2 h-18"
                })
              ],
              className: "w-78.75"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "flex m-auto w-60",
                  alt: "seller",
                  src: StaticAsset.src("/static/images/consumer.png")
                }),
                JsxRuntime.jsx("h4", {
                  children: "Потребитель",
                  className: "h4 text-center text-black-landing mt-8"
                }),
                JsxRuntime.jsx("p", {
                  children: "Просто учитывайте входящие СНТ в кабинете.",
                  className: "paragraph text-center text-gray-landing mt-2 h-18"
                })
              ],
              className: "w-78.75"
            })
          ],
          className: "flex m-auto justify-between w-252"
        }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "flex m-auto mt-6 lg:mt-20",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "start_using"),
        onClick: (function (param) {
          Buhta_landing__EventHandlers.scrollToFooter(deviceType);
        })
      }),
      JsxRuntime.jsx("p", {
        children: "Уже пользуются 125 предпринимателей",
        className: "paragraph-small text-center text-gray-landing mt-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "-ml-4 lg:ml-0",
            src: StaticAsset.src("/static/icons/guard-circled.svg")
          }),
          JsxRuntime.jsx("h3", {
            children: "Автоматизируйте весь бизнес-процесс покупки и продажи товаров и услуг!",
            className: "h4 lg:h3 text-black-landing lg:w-180 lg:text-center"
          }),
          JsxRuntime.jsx("p", {
            children: "С помощью Бухты вы сможете построить весь процесс от приобретения товаров и услуг, их хранения и продажи в одной системе. Объединяя документы по сделке вы сможете очень просто ориентироваться в вашем бизнесе и находить документы за считанные секунды!",
            className: "paragraph lg:h-light text-gray-landing lg:w-180 mt-2 lg:text-center"
          })
        ],
        className: "lg:w-252 pt-8 lg:pt-18 pb-10 lg:pb-20 block sm:flex flex-col items-start sm:items-center m-auto mt-10 lg:mt-40 sm:mb-20 px-6 sm:px-48 lg:px-0 lg:rounded-sm bg-bg"
      })
    ]
  });
}

const make = ESFOutro;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
